import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { Locale, ZonaLocale } from 'src/app/model/locale';
import { LocaliService } from 'src/app/services/locali/locali.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-piantina',
  templateUrl: './piantina.component.html',
  styleUrls: ['./piantina.component.scss'],
})
export class PiantinaComponent implements OnInit, OnDestroy {

  @Input() selectable: boolean;
  @Input() locale: Locale;

  checked: ZonaLocale[] = [];

  private _subscriptions: Subscription[] = [];

  constructor(
    private _utilsService: UtilsService,
    private _localiService: LocaliService,
    private _route: ActivatedRoute,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this._subscriptions?.forEach(s => s.unsubscribe());
  }

  dismiss() {
    this._utilsService.dismiss(this.checked);
  }

  selectZone(event) {
    console.log(event);
    const checked = event?.target?.checked;
    const zona: ZonaLocale = event?.target?.value;

    this.checked = this.checked.filter(z => z.id !== zona.id);
    if (checked) {
      this.checked.push(zona);
    }
  }

  get piantina() {
    return `assets/${this.locale?.id}/piantina.jpeg`;
  }
}
